export type FeatureFlag = {
  id: string;
  name: string;
  isEnabled: boolean;
};

/** Names the API may return; keep in sync with DB feature flags and backend usage. */
export const FEATURE_FLAG_NAMES = [
  'isGoogleAuthEnabled',
  'isAppleAuthEnabled',
  'isSearchFilterEnabled',
  'isWorksheetFeedbackSummaryEnabledForB2C',
  'isWorksheetFeedbackSummaryEnabledForB2B',
  'isAdminImpersonationEnabled',
  'isWorksheetPrintingEnabled',
] as const;

export type FeatureFlagName = (typeof FEATURE_FLAG_NAMES)[number];

export type FeatureFlagMap = Map<FeatureFlagName, boolean>;

export const isFeatureFlagName = (name: string): name is FeatureFlagName =>
  (FEATURE_FLAG_NAMES as readonly string[]).includes(name);
